
                import "css-modules://src_components_quote"
                export default {"Main":"_ef7e1c","NoPadding":"_46a133","Author":"_50a212","Quote":"_0f2468"}
            